import { render, staticRenderFns } from "./widgetTextFilter.vue?vue&type=template&id=02828514&scoped=true"
import script from "./widgetTextFilter.vue?vue&type=script&lang=js"
export * from "./widgetTextFilter.vue?vue&type=script&lang=js"
import style0 from "./widgetTextFilter.vue?vue&type=style&index=0&id=02828514&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02828514",
  null
  
)

export default component.exports